export default function Footer() {
  const WA_GROUP = "https://chat.whatsapp.com/DPJtuxEsuEJ8tcSJJZpDMg?mode=gi_t";
  return (
    <footer className="border-t border-bizma-border bg-bizma-cream/60 mt-16" data-testid="app-footer">
      <div className="container-x py-8 flex flex-col sm:grid sm:grid-cols-3 gap-3 sm:gap-6 text-sm text-bizma-subtext text-center sm:text-left">
        <div>© {new Date().getFullYear()} BIZMA. Grow Together.</div>
        <div className="sm:text-center">Komunitas Pelaku Usaha Magelang</div>
        <div className="flex flex-col sm:flex-row sm:justify-end items-center gap-2 sm:gap-4">
          <a href="/" className="hover:text-bizma-terracotta transition-colors" data-testid="footer-home">Halaman Depan</a>
          <a href={WA_GROUP} target="_blank" rel="noreferrer" className="text-bizma-terracotta hover:underline transition-colors" data-testid="footer-wa-group">
            Gabung Grup WhatsApp
          </a>
        </div>
      </div>
    </footer>
  );
}
